<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>更改电话</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="update-phone">
            <el-form label-width="120px" :model="editForm" ref="editForm">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="新电话号码">
                            <el-input size="small" v-model="editForm.phone" auto-complete="off"
                                      placeholder="请输入新电话号码"></el-input>
                        </el-form-item>
                        <el-form-item label="验证码">
                            <el-input size="small" v-model="editForm.code" auto-complete="off"
                                      placeholder="请输入6位验证码"></el-input>
                            <div class="code"><span>|</span><span @click="getcode()">{{codeText}}</span></div>
                        </el-form-item>
                        <el-form-item>
                            <div class="dialog-footer">
                                <el-button size="small" type="primary" class="title"
                                           @click="submitForm('editForm')">保存
                                </el-button>
                                <el-button size="small" @click="closeDialog">取消</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {getCodes, updatePhone} from "../../api/userMG";

    export default {
        data() {
            return {
                title: '修改电话号码',
                editForm: {
                    code: '',
                    phone: '',
                },
                canClick: true,
                second: 60,
                codeText: '获取验证码',
                listData: [], //用户数据
                rules: {
                    phone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {required: true, message: '请输入正确的手机号', trigger: 'blur', min: 11, max: 11}
                    ],
                    code: [
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                        {required: true, message: '请输入正确的验证码', trigger: 'blur', min: 6, max: 6}
                    ]
                }
            }
        },
        // 注册组件
        components: {},
        /**
         * 创建完毕
         */
        created() {
        },

        /**
         * 里面的方法只有被调用才会执行
         */
        methods: {
            // 编辑、增加页面保存方法
            submitForm(editData) {
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        updatePhone(this.editForm)
                            .then(res => {
                                if (res.code == 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '保存成功！'
                                    })
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: '保存失败！'
                                    })
                                }
                            })
                            .catch(err => {
                                this.$message.error('更改电话号码失败，请稍后再试！')
                            })
                    } else {
                        return false
                    }
                })
            },
            getcode() {
                let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
                if (!myreg.test(this.editForm.phone)) {
                    this.$message({
                        type: 'error',
                        message: '请填写正确的手机号'
                    })
                    return false;
                }
                if (this.canClick) {
                    getCodes({phone: this.editForm.phone, webType: 'update'}).then(res => {
                            if (res.code == 200) {
                                this.canClick = false
                                this.codes = res.codes
                                this.$message({
                                    type: 'success',
                                    message: '发送成功'
                                })
                                this.timer()
                            } else {
                                this.$message({
                                    type: 'fail',
                                    message: res.message
                                })
                            }
                        }
                    )
                }
            },
            timer() {
                if (this.second > 0) {
                    this.second--;
                    this.codeText = this.second + "s";
                    setTimeout(this.timer, 1000);
                } else {
                    this.second = 0;
                    this.codeText = "获取验证码";
                    this.canClick = true;
                }
            },
            closeDialog() {
                this.editForm = {phone: '', code: ''}
            }
        }
    }
</script>

<style scoped>
    .update-phone {
        margin-top: 40px;
    }

    .code {
        position: absolute;
        margin-top: -40px;
        right: 10px;
        color: #0052D9;
    }

    .code span {
        padding-left: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/views/user/phone.vue